export function patchProgram(program, patch) {
    const next = program.clone();
    if (patch.programNameFull !== undefined) next.programNameFull = patch.programNameFull;
    if (patch.programNameShort !== undefined) next.programNameShort = patch.programNameShort;
    if (patch.contractNumber !== undefined) next.contractNumber = patch.contractNumber;
    if (patch.contractTitle !== undefined) next.contractTitle = patch.contractTitle;
    if (patch.pricingType !== undefined) next.pricingType = patch.pricingType;
    if (patch.operationalStateId !== undefined) next.operationalStateId = patch.operationalStateId;
    if (patch.recordStatusId !== undefined) next.recordStatusId = patch.recordStatusId;
    if (patch.contractLifecycleStateId !== undefined) {
        next.contractLifecycleStateId = patch.contractLifecycleStateId;
    }
    if (patch.deliveryModelTypeId !== undefined) next.deliveryModelTypeId = patch.deliveryModelTypeId;
    if (patch.governmentOrganizationId !== undefined) {
        next.governmentOrganizationId = patch.governmentOrganizationId;
    }
    if (patch.customerOrgId !== undefined) next.customerOrgId = patch.customerOrgId;
    if (patch.sectorId !== undefined) next.sectorId = patch.sectorId;
    if (patch.businessUnitId !== undefined) next.businessUnitId = patch.businessUnitId;
    if (patch.portfolioId !== undefined) next.portfolioId = patch.portfolioId;
    if (patch.onHoldSince !== undefined) next.onHoldSince = patch.onHoldSince || undefined;
    if (patch.companyRoleType !== undefined) next.companyRoleType = patch.companyRoleType;
    if (patch.primeContractorCompanyId !== undefined) {
        next.primeContractorCompanyId = patch.primeContractorCompanyId;
    }
    return next;
}
